export let URL_MIDIS:string;
export let URL_AUTH:string;
export let URLAPI:string;
export let URL_DOWNLOAD:string;
export let URL_IMAGE:string;

// URL_MIDIS = 'https://olfdif.midis.com:82'
URL_MIDIS = 'https://portail2025.midis.com:82'
// URL_AUTH = 'https://olfdif.midis.com:82/auth'
URL_AUTH = 'https://portail2025.midis.com:82/auth'
// URLAPI = 'https://olfdif.midis.com:82/api/v1/'
URLAPI = 'https://portail2025.midis.com:82/api/v1/'
// URL_DOWNLOAD = 'https://portail2025.midis.com:82/cedric.php?fichier='
URL_DOWNLOAD = 'https://portail2025.midis.com'

// Marge accordee au client pour prolonger la fin d'une campagne (en jours).
export const MARGE_FIN_CAMPAGNE_JOURS = 7;
// Marge accordee pour anticiper le debut d'une campagne (en jours).
export const MARGE_DEBUT_CAMPAGNE_JOURS = 7;

// if(process.env.REACT_APP_ENV ==="production"){
//     URL_MIDIS = 'https://someAPI.com'
//     URL_AUTH = 'https://someAPI.com/auth'
//     URLAPI = 'https://someAPI.com/api/v1/'
// }else if(process.env.REACT_APP_ENV ==="development"){
//     // URL_MIDIS = 'https://olfdif.midis.com:82'
//     URL_MIDIS = 'https://portail2025.midis.com:82'
//     // URL_AUTH = 'https://olfdif.midis.com:82/auth'
//     URL_AUTH = 'https://portail2025.midis.com:82/auth'
//     // URLAPI = 'https://olfdif.midis.com:82/api/v1/'
//     URLAPI = 'https://portail2025.midis.com:82/api/v1/'
// }
